var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrders(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "encomiendas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 60,
    height: 45,
    transform: "translate(719 625)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 43.773,
    height: 43.658,
    fill: "#85af26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_17",
    "data-name": "Mask Group 17",
    transform: "translate(-719 -625)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(728 626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M43.773,11.78a1.467,1.467,0,0,0-.93-1.483C36.914,7.349,30.5,4.143,22.665.208A1.554,1.554,0,0,0,21.13.2C14.6,3.479,7.941,6.809.779,10.376A1.289,1.289,0,0,0,0,11.666c.011,2.543.009,5.128.008,7.629v4.978c0,2.543,0,5.172-.007,7.758a1.256,1.256,0,0,0,.775,1.246c7.05,3.514,13.9,6.94,20.358,10.183a1.677,1.677,0,0,0,.759.2,1.619,1.619,0,0,0,.735-.19c7.359-3.693,13.988-7.008,20.267-10.133a1.418,1.418,0,0,0,.877-1.424c-.017-7.075-.017-13.66,0-20.131M22.878,22.753c0-.255.021-.33.217-.428,4.91-2.443,9.9-4.937,14.719-7.349L41.7,13.035,41.764,13v3.151q0,7.593,0,15.185c0,.258-.025.335-.216.431-4.935,2.456-9.948,4.962-14.8,7.386L22.9,41.083l-.019.009V37.966q0-7.606,0-15.213M40.537,11.386l-.063.032L36.631,13.34Q29.4,16.956,22.166,20.578a.5.5,0,0,1-.54.008c-1.216-.622-2.458-1.243-3.659-1.842l-1.329-.664-.023-.011,8.2-4.357c3.145-1.67,6.4-3.4,9.59-5.1a.523.523,0,0,1,.576-.006c1.336.682,2.7,1.362,4.02,2.021l1.513.756.02.01m-19.654,29.7-.14-.068L16.26,38.773q-6.993-3.5-13.988-6.991c-.233-.116-.278-.155-.278-.34C2.005,26.529,2,21.533,2,16.7V13l.047.022,1.533.768C4.773,14.386,6,15,7.216,15.6a.357.357,0,0,1,.256.4c-.012,1.88-.011,3.791-.009,5.639v1.4c0,.93.346,1.277,1.277,1.278l.528,0c.471,0,.958.008,1.439-.011a.68.68,0,0,1,.575.251c.48.5.977.991,1.457,1.469q.423.422.845.845a1.029,1.029,0,0,0,1.844-.779c0-1.669,0-3.338,0-5.041V19.712l3.411,1.7.463.23c.475.235.966.478,1.437.734a.367.367,0,0,1,.137.187c.012,6.076.01,12.255.009,18.229ZM13.428,23.326v.591l-.072-.072c-.327-.331-.635-.644-.926-.966a1.577,1.577,0,0,0-1.231-.572q-.057,0-.116,0c-.41.023-.821.018-1.255.013l-.33,0V16.748l1.224.611.651.323c.619.306,1.259.623,1.877.951a.424.424,0,0,1,.166.214c.017,1.492.014,3.011.012,4.48m1.185-6.467a.486.486,0,0,1-.314.043c-1.037-.5-2.083-1.028-3.1-1.539l-.553-.279,6.85-3.639c3.584-1.9,7.29-3.872,10.931-5.816a.515.515,0,0,1,.575-.02c.924.48,1.84.934,2.81,1.415l.68.338c-6.626,3.523-12.156,6.464-17.884,9.5M26.488,4.409,22.481,6.538C18.033,8.9,13.433,11.345,8.915,13.761a.825.825,0,0,1-.906.022c-1.23-.64-2.456-1.249-3.754-1.895l-1.011-.5L7.26,9.376c4.669-2.334,9.5-4.747,14.242-7.132a.737.737,0,0,1,.79.006c1.1.574,2.2,1.118,3.362,1.693l.883.438-.049.027",
    transform: "translate(0 0)",
    fill: "#85af26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrders);
export default __webpack_public_path__ + "static/media/icon_orders.2b46c30dd3855f8e3d9cd489c19ac9b6.svg";
export { ForwardRef as ReactComponent };